/* eslint-disable import/no-anonymous-default-export */
import split from 'lodash/split'
import toNumber from 'lodash/toNumber'
import toString from 'lodash/toString'
import isValueValid from './isValueValid'
import getMonthName from './getMonthName'
import getMonthShortName from './getMonthShortName'

export default ({ date, format= 'short', mode= 'BE'}) => {
  if (!isValueValid(date)) return ''
  const language = mode === 'BE' ? 'TH' : 'EN'
  const [_year, _month, _date] = split(date, '-')
  const monthName = format === 'short' ? getMonthShortName({ month: _month, language }) : getMonthName({ month: _month, language })
  let year = mode === 'BE' ? toNumber(_year) + 543 : _year
  if (format === 'short') year = toString(year).substring(2)

  if (mode === 'BE') return `${_date} ${monthName} ${year}`
  if (mode === 'AD') return `${monthName} ${_date}, ${year}`
}